export const consultationCondition: any = {
  withWhom: "誰と行きますか？",
  hopeForHotel: "ホテルの希望",
  hopeForFlight: "フライトの希望",
};
